import { useMemo, useState } from "react";
import { dayjs } from "utils";

const getMonday = (date: Date) => {
  const base = dayjs(date);
  const dow = base.day();
  // Adjust to Sunday as the start of the week (Sun=0..Sat=6)
  return base.subtract(dow, "day");
};

const isSameDate = (a: Date, b: Date) => dayjs(a).isSame(dayjs(b), "day");

const getWeekDays = (baseDate: Date, weekOffset: number): Date[] => {
  const base = dayjs(baseDate).add(weekOffset * 7, "day");
  const weekStart = getMonday(base.toDate());
  const days: Date[] = [];
  for (let i = 0; i < 7; i += 1) {
    days.push(weekStart.add(i, "day").toDate());
  }
  return days;
};

export interface UseWeekCalendarParams {
  value: Date;
  onChange?: (date: Date) => void;
}

export interface UseWeekCalendarResult {
  weekDays: Date[];
  showDatePicker: boolean;
  toggleDatePicker: () => void;
  handleDateClick: (date: Date) => void;
  handleDatePickerSelect: (date: Date | undefined) => void;
  isSameDate: (a: Date, b: Date) => boolean;
}

export const useWeekCalendar = (
  params: UseWeekCalendarParams,
): UseWeekCalendarResult => {
  const { value, onChange } = params;
  const [showDatePicker, setShowDatePicker] = useState(false);

  // 周视图始终基于当前受控值 value 所在周（周日到周六）
  const weekDays = useMemo(() => getWeekDays(value, 0), [value]);

  const toggleDatePicker = () => setShowDatePicker((v) => !v);

  const handleDateClick = (date: Date) => {
    onChange?.(date);
  };

  const handleDatePickerSelect = (date: Date | undefined) => {
    if (!date) {
      return;
    }
    onChange?.(date);
    setShowDatePicker(false);
    // 不再维护周偏移；由外部 value 变更触发周视图自动切换
  };

  return {
    weekDays,
    showDatePicker,
    toggleDatePicker,
    handleDateClick,
    handleDatePickerSelect,
    isSameDate,
  };
};
